import React, { useState, useEffect } from "react";
import axios from "axios";
import getAPI from "../../service/getAPI";
import Changepassword from "./Profile-changepassword";

function Profile() {
  const { master } = getAPI();
  const [activeProfileTab, setActiveProfileTab] = useState("profile-overview");
  const [user, setUser] = useState(null);

  // Edit form state
  const [editForm, setEditForm] = useState({
    store_name: "",
    mobile_no: "",
    address: "",
    area: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    lat: "",
    lng: "",
  });

  const [savingDetails, setSavingDetails] = useState(false);
  const [editSuccessMsg, setEditSuccessMsg] = useState("");
  const [editErrorMsg, setEditErrorMsg] = useState("");

  // Fetch user details from localStorage
  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = () => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser(parsed);
        setEditForm({
          store_name: parsed.store_name || "",
          mobile_no: parsed.mobile_no || "",
          address: parsed.address || "",
          area: parsed.area || "",
          city: parsed.city || "",
          state: parsed.state || "",
          country: parsed.country || "India",
          pincode: parsed.pincode || "",
          lat: parsed.lat || "",
          lng: parsed.lng || "",
        });
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    setEditErrorMsg("");
    setEditSuccessMsg("");
  };

  const handleSaveDetails = async (e) => {
    e.preventDefault();
    setEditErrorMsg("");
    setEditSuccessMsg("");

    if (!editForm.store_name.trim() || !editForm.mobile_no.trim()) {
      setEditErrorMsg("Store Name and Mobile Number are required.");
      return;
    }

    try {
      setSavingDetails(true);
      const payload = {
        store_id: user?.store_id,
        user_type: user?.user_type || (user?.store_id === 1 ? "admin" : "store"),
        store_name: editForm.store_name.trim(),
        mobile_no: editForm.mobile_no.trim(),
        address: editForm.address.trim(),
        area: editForm.area.trim(),
        city: editForm.city.trim(),
        state: editForm.state.trim(),
        country: editForm.country.trim() || "India",
        pincode: editForm.pincode.trim(),
        lat: editForm.lat.trim(),
        lng: editForm.lng.trim(),
        is_active: user?.is_active ?? 1,
      };

      const res = await axios.post(master.storeEdit, payload);

      if (res.data.flag === 1) {
        // Update user state and localStorage
        const updatedUser = {
          ...user,
          ...payload,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setUser(updatedUser);
        setEditSuccessMsg("Branch details updated successfully!");
      } else {
        setEditErrorMsg(res.data.message || "Failed to update branch details.");
      }
    } catch (err) {
      console.error("Save details error:", err);
      setEditErrorMsg(err.response?.data?.message || "An error occurred while saving details.");
    } finally {
      setSavingDetails(false);
    }
  };

  const isMainAdmin = user?.store_id === 1 || user?.user_type === "admin";

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Branch Profile & Settings</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/admin/dashboard">Home</a>
            </li>
            <li className="breadcrumb-item active">Branch Profile</li>
          </ol>
        </nav>
      </div>

      <section className="section profile">
        <div className="row">
          {/* Left Branch Card */}
          <div className="col-xl-4 mb-4">
            <div className="card shadow-sm border-0">
              <div className="card-body profile-card pt-4 d-flex flex-column align-items-center text-center">
                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "90px", height: "90px" }}
                >
                  <i className="bi bi-shop text-success fs-1"></i>
                </div>
                <h4 className="fw-bold text-dark mb-1">{user?.store_name || "Branch Name"}</h4>
                <div className="text-muted small mb-2">
                  ID: #{user?.store_id || 1} • {user?.mobile_no}
                </div>
                {isMainAdmin ? (
                  <span className="badge bg-primary px-3 py-2">
                    <i className="bi bi-shield-check me-1"></i>MAIN ADMIN BRANCH
                  </span>
                ) : (
                  <span className="badge bg-success px-3 py-2">
                    <i className="bi bi-geo-alt me-1"></i>RETAIL BRANCH
                  </span>
                )}

                <hr className="w-100 my-3" />

                <div className="w-100 text-start small text-muted">
                  <div className="mb-2 d-flex align-items-center gap-2">
                    <i className="bi bi-geo-alt text-primary fs-6"></i>
                    <span>
                      <strong className="text-dark">Location:</strong>{" "}
                      {[user?.city, user?.state].filter(Boolean).join(", ") || "N/A"}
                    </span>
                  </div>
                  <div className="mb-2 d-flex align-items-center gap-2">
                    <i className="bi bi-telephone text-primary fs-6"></i>
                    <span>
                      <strong className="text-dark">Phone:</strong> {user?.mobile_no || "N/A"}
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-calendar3 text-primary fs-6"></i>
                    <span>
                      <strong className="text-dark">Joined:</strong>{" "}
                      {user?.created_at ? new Date(user.created_at).toLocaleDateString("en-IN") : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Tabs Card */}
          <div className="col-xl-8">
            <div className="card shadow-sm border-0">
              <div className="card-body pt-3">
                {/* Navigation Tabs */}
                <ul className="nav nav-tabs nav-tabs-bordered" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link fw-bold ${activeProfileTab === "profile-overview" ? "active" : ""}`}
                      type="button"
                      role="tab"
                      onClick={() => setActiveProfileTab("profile-overview")}
                    >
                      <i className="bi bi-info-circle me-1"></i> Overview
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link fw-bold ${activeProfileTab === "profile-edit" ? "active" : ""}`}
                      type="button"
                      role="tab"
                      onClick={() => setActiveProfileTab("profile-edit")}
                    >
                      <i className="bi bi-pencil-square me-1"></i> Edit Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link fw-bold ${activeProfileTab === "profile-change-password" ? "active" : ""}`}
                      type="button"
                      role="tab"
                      onClick={() => setActiveProfileTab("profile-change-password")}
                    >
                      <i className="bi bi-key me-1"></i> Change Password
                    </button>
                  </li>
                </ul>

                <div className="tab-content pt-3">
                  {/* 🟢 TAB 1: OVERVIEW */}
                  {activeProfileTab === "profile-overview" && (
                    <div className="tab-pane fade show active profile-overview">
                      <h5 className="card-title fw-bold mb-3">Branch Details</h5>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Branch Name</div>
                        <div className="col-lg-9 col-md-8 fw-bold text-dark">{user?.store_name || "N/A"}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Mobile No</div>
                        <div className="col-lg-9 col-md-8">{user?.mobile_no || "N/A"}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Full Address</div>
                        <div className="col-lg-9 col-md-8">
                          {[user?.address, user?.area, user?.city, user?.state, user?.country, user?.pincode].filter(Boolean).join(", ") || "N/A"}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Area / City</div>
                        <div className="col-lg-9 col-md-8">{[user?.area, user?.city].filter(Boolean).join(", ") || "N/A"}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">State / Country</div>
                        <div className="col-lg-9 col-md-8">{[user?.state, user?.country || "India"].filter(Boolean).join(", ") || "N/A"}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Pincode</div>
                        <div className="col-lg-9 col-md-8">{user?.pincode || "N/A"}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Coordinates</div>
                        <div className="col-lg-9 col-md-8">
                          {user?.lat && user?.lng ? (
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${user.lat},${user.lng}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary text-decoration-none"
                            >
                              <i className="bi bi-geo-alt-fill me-1"></i>
                              {user.lat}, {user.lng} (View on Google Maps)
                            </a>
                          ) : (
                            <span className="text-muted">Not specified</span>
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-4 text-muted fw-semibold">Status</div>
                        <div className="col-lg-9 col-md-8">
                          <span className={`badge ${user?.is_active === 1 || user?.is_active === true ? "bg-success" : "bg-secondary"}`}>
                            {user?.is_active === 1 || user?.is_active === true ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* 🟢 TAB 2: EDIT BRANCH DETAILS */}
                  {activeProfileTab === "profile-edit" && (
                    <div className="tab-pane fade show active profile-edit pt-2">
                      <h5 className="card-title fw-bold mb-3">Edit Branch Details</h5>

                      {editSuccessMsg && (
                        <div className="alert alert-success d-flex align-items-center mb-3" role="alert">
                          <i className="bi bi-check-circle-fill me-2 fs-5"></i>
                          <div>{editSuccessMsg}</div>
                        </div>
                      )}

                      {editErrorMsg && (
                        <div className="alert alert-danger d-flex align-items-center mb-3" role="alert">
                          <i className="bi bi-exclamation-triangle-fill me-2 fs-5"></i>
                          <div>{editErrorMsg}</div>
                        </div>
                      )}

                      <form onSubmit={handleSaveDetails}>
                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">
                            Store Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="store_name"
                              value={editForm.store_name}
                              onChange={handleEditChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">
                            Mobile No <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="mobile_no"
                              value={editForm.mobile_no}
                              onChange={handleEditChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">Address</label>
                          <div className="col-md-9">
                            <textarea
                              className="form-control"
                              rows="2"
                              name="address"
                              value={editForm.address}
                              onChange={handleEditChange}
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">Area</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="area"
                              value={editForm.area}
                              onChange={handleEditChange}
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">City</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={editForm.city}
                              onChange={handleEditChange}
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">State</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="state"
                              value={editForm.state}
                              onChange={handleEditChange}
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">Pincode</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="pincode"
                              value={editForm.pincode}
                              onChange={handleEditChange}
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-md-3 col-form-label fw-semibold text-muted">Coordinates</label>
                          <div className="col-md-9">
                            <div className="row g-2">
                              <div className="col-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Latitude (e.g. 21.1702)"
                                  name="lat"
                                  value={editForm.lat}
                                  onChange={handleEditChange}
                                />
                              </div>
                              <div className="col-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Longitude (e.g. 72.8311)"
                                  name="lng"
                                  value={editForm.lng}
                                  onChange={handleEditChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-9 offset-md-3">
                            <button type="submit" className="btn btn-success fw-bold px-4" disabled={savingDetails}>
                              {savingDetails ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                  Saving...
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-save me-2"></i>Save Details
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}

                  {/* 🟢 TAB 3: CHANGE PASSWORD */}
                  {activeProfileTab === "profile-change-password" && (
                    <Changepassword user={user} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Profile;
